<template>
  <div class="logic-builder-component logic-builder-wrapper">
    <div class="modal task">
      <div class="modal-close" @click="close"></div>
      <div class="custom-modal-header">Logik</div>
      <div
        class="content logic-builder-component fancy-scroll"
        @scroll.passive="showScrollbar"
      >
        <LogicBuilderComponent
          ref="logicComponentRef"
          :task="getFilteredInputTaskForLogicBuilder"
          :selectableElementList="getPreviousSelectableElementList"
          :defaultStatementAndLogicNodes="
            this.task.props.defaultStatementAndLogicNodes
          "
          @onStatementOrLogicNodeChange="onStatementOrLogicNodeChange"
          @setFeedBackForRule="setFeedBackForRule"
          :apiVersion="getFlowRunnerUrlVersion"
          v-show="!loading"
        ></LogicBuilderComponent>
      </div>
      <div class="loading-container" v-if="loading">
        <LoadingSpinner loadingCaption="Wird gespeichert..." v-show="loading" />
      </div>
    </div>
  </div>
</template>

<script>
import { LogicBuilderComponent } from '@codelos.io/logic-builder';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import '@codelos.io/logic-builder/dist/logic-builder.css';
import { debouncer, getApiEndpointVersion } from '../../utils/helpers';

export default {
  name: 'logicBuilderWrap',

  props: {
    task: Object,
    process: Object,
  },

  data() {
    return {
      loading: false,
      isRunLogicTask: false,
    };
  },
  methods: {
    async close() {
      let output;
      this.loading = true;
      if (!this.isRunLogicTask) {
        try {
          output = await this.$refs.logicComponentRef.getLogicOutput();
        } catch (error) {}
      } else {
        output = this.$refs.logicComponentRef.getTaskOutput();
      }

      if (output && output.length > 0) {
        this.task.output = [...output];
        this.$set(
          this.task,
          'output',
          this.task.output.concat(this.task.input)
        );
      } else {
        this.$set(this.task, 'output', this.task.input);
      }

      setTimeout(() => {
        this.loading = false;
        this.$emit('close');
      }, 1000);
    },

    onStatementOrLogicNodeChange(event) {
      this.isRunLogicTask = false;
      this.task.props.defaultStatementAndLogicNodes = event;
    },
    setFeedBackForRule(event) {
      if (event.isAllRunPass && !event.isSingleRun) this.isRunLogicTask = true;
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
  },

  computed: {
    getFilteredInputTaskForLogicBuilder() {
      const unwantedTypes = ['file', 'dataframe'];
      const copyOfTask = JSON.parse(JSON.stringify(this.task));
      copyOfTask.input = copyOfTask.input.filter(
        (input) =>
          input.label !== 'codelosSettings' &&
          !unwantedTypes.includes(input.type)
      );
      return copyOfTask;
    },
    getPreviousSelectableElementList() {
      const taskMap = new Map(
        this.process.tasks.map((task) => [task.id, task])
      );
      let previousTaskElements = [];

      let currentTask = taskMap.get(this.task.id);

      while (currentTask && currentTask.previousTaskId !== null) {
        const previosTask = taskMap.get(currentTask.previousTaskId);
        if (
          previosTask &&
          ['Start', 'Form'].includes(previosTask.name) &&
          previosTask?.props?.formTrigger?.elements?.length
        ) {
          const filterElement = previosTask.props.formTrigger.elements.filter(
            (element) => ['radio', 'select'].includes(element.type)
          );
          previousTaskElements = [...previousTaskElements, ...filterElement];
        }
        currentTask = previosTask;
      }

      return previousTaskElements;
    },
    getFlowRunnerUrlVersion() {
      if (
        this.process.settings.hasOwnProperty('apiEndpoint') &&
        this.process.settings.apiEndpoint != ''
      ) {
        return getApiEndpointVersion(this.process.settings.apiEndpoint);
      } else return 7;
    },
  },

  components: {
    LogicBuilderComponent,
    LoadingSpinner,
  },
};
</script>

<style scoped>
.logic-builder-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logic-builder-wrapper .loading-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  height: calc(100% - 36px - 36px);
  overflow-y: auto;
  margin-top: 36px;
}

.pull-right {
  float: right;
}

.btn-close {
  position: relative;
  z-index: 9;
  top: 10px;
  right: 5px;
  padding: 10px 10px;
}

.progress-icon-wrapper {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  text-align: center;
}

.progress-icon-wrapper .progress-icon {
  left: unset;
  margin: 0 auto;
  top: unset;
  margin-top: 30px;
}
.progress-icon-wrapper .progress-icon:after {
  border-color: #313745 transparent #313745 transparent;
}
::v-deep .logic-builder-component * {
  box-sizing: border-box;
}
.logic-builder-component .logic-builder-main-wrap {
  box-shadow: none;
  border: none;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100%;
}

::v-deep .logic-builder-component .dropdown-menu.show {
  bottom: unset;
  min-width: 150px;
  box-sizing: border-box;
}
::v-deep .logic-builder-component .dropdown-item {
  box-sizing: border-box;
}
::v-deep a.dropdown-item span {
  line-height: 24px;
  display: inline-block;
}

::v-deep .logic-builder-component .new-rule-header .new-rule-title-wrap {
  color: #333137;
}

::v-deep .logic-builder-component .collapse {
  width: auto !important;
}

::v-deep .logic-builder-component .conditionStatement-builder-inner fieldset {
  border: 1px dashed rgb(0 0 0 / 36%);
}
::v-deep
  .logic-builder-component
  .conditionStatement-builder-dropdown
  .input-wrap
  .icon {
  top: calc(50% - 0px);
}
::v-deep .logic-builder-component .conditionStatement-and-or-buttons li button {
  font-size: 16px;
}

::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}
.conditionStatement-builder .title-wrap ::v-deep .setRulesBtn {
  height: 38px;
}

.rule-btn-wrap {
  display: flex;
  align-items: center;
}
::v-deep .logic-builder-component .operator-selection select {
  line-height: normal;
}
::v-deep .logic-builder-component .conditionStatement-and-or-buttons {
  font-size: 16px;
  color: #000;
  position: relative;
  top: -8px;
}
::v-deep .logic-builder-component .inline,
::v-deep .logic-builder-component .delete-rule {
  color: #2c3e50;
}
::v-deep .logic-builder-component .add-new-input {
  font-size: 16px;
}
::v-deep .logic-builder-component .when-rule-inner .pl-4 {
  height: auto;
}

::v-deep .remove-condition-block svg {
  font-size: 20px;
  color: #323338;
}
</style>
